import { useCallback } from 'react'
import { Box, Typography, Alert, Button, Stack } from '@mui/material'
import { AccessTimeOutlined as TimeIcon, Refresh as RefreshIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

export const SessionExpired = () => {
  const { t } = useTranslation()

  const handleReAuthenticate = useCallback(() => {
    // Trigger re-authentication
    window.location.reload()
  }, [])

  const handleReturnToMain = useCallback(() => {
    window.location.href = '/'
  }, [])

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      textAlign="center"
      sx={{ p: 3 }}
    >
      <TimeIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
      
      <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 500 }}>
        Session Expired
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
        Your session has expired for security reasons. Please log in again to continue.
      </Typography>

      <Alert severity="error" sx={{ mb: 3, maxWidth: 400 }}>
        For your security, you have been logged out due to inactivity.
      </Alert>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleReAuthenticate}
          size="large"
          startIcon={<RefreshIcon />}
        >
          Login Again
        </Button>
        
        <Button 
          variant="outlined" 
          color="primary" 
          onClick={handleReturnToMain}
          size="large"
        >
          {t('ReturnToChat') || 'Return to Chat'}
        </Button>
      </Stack>
    </Box>
  )
}
